export const complaint = {
  "Sanitation & Garbage": [
    "Garbage not collected",
    "Overflowing dustbins",
    "Illegal dumping",
    "Street not cleaned",
    "Drain blockage",
    "Open sewage",
    "Bad odor in area",
  ],

  "Street Light & Electricity": [
    "Street light not working",
    "Flickering light",
    "Electric pole damaged",
    "Hanging wires",
    "Power outage in area",
  ],

  "Traffic & Roads": [
    "Broken traffic signal",
    "Potholes",
    "Road damaged",
    "Road blockage",
    "Missing road signs",
    "Illegal parking",
    "Traffic congestion issue",
  ],

  "Parks & Public Spaces": [
    "Park not maintained",
    "Broken benches",
    "Damaged play equipment",
    "No lighting in park",
    "Garbage in park",
  ],

  "Animal Issues": [
    "Dead animal on road",
    "Stray dog issue",
    "Injured animal",
    "Animal nuisance (attacks/noise)",
    "Cattle on road",
  ],

  "Water Supply & Drainage": [
    "Water leakage",
    "No water supply",
    "Dirty water",
    "Low water pressure",
    "Drain overflow",
    "Water logging",
  ],

  "Public Infrastructure": [
    "Broken footpath",
    "Damaged public toilet",
    "Bus stop damaged",
    "Government building issue",
    "Encroachment on public land",
  ],

  "Noise & Pollution": [
    "Loud noise (DJ, construction)",
    "Air pollution",
    "Burning garbage",
    "Dust pollution",
  ],

  "Safety & Emergency": [
    "Open manhole",
    "Fire hazard",
    "Unsafe construction",
    "Building collapse risk",
    "Fallen tree",
  ],

  "Public Health & Hygiene": [
    "Mosquito breeding",
    "Dirty public toilets",
    "Unhygienic food stalls",
    "Infection risk area",
  ],
};